import { render, staticRenderFns } from "./kdxTagLabel.g.vue?vue&type=template&id=8f0347da&scoped=true"
import script from "./kdxTagLabel.g.vue?vue&type=script&lang=js"
export * from "./kdxTagLabel.g.vue?vue&type=script&lang=js"
import style0 from "./kdxTagLabel.g.vue?vue&type=style&index=0&id=8f0347da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0347da",
  null
  
)

export default component.exports